module.exports = __webpack_public_path__ + "static/media/How to create a simple tax invoice.949ae961.png";